import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Guard, Result, UseCase } from '@digibricks/core';
export var BAN_EXAMINATION_SUBMISSION_USE_CASE = 'BAN_EXAMINATION_SUBMISSION_USE_CASE';
export var BanExaminationSubmissionUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(BanExaminationSubmissionUseCase, _UseCase);

  var _super = _createSuper(BanExaminationSubmissionUseCase);

  function BanExaminationSubmissionUseCase(examinationSubmissionRepository) {
    var _this;

    _classCallCheck(this, BanExaminationSubmissionUseCase);

    _this = _super.call(this);
    _this.examinationSubmissionRepository = examinationSubmissionRepository;
    return _this;
  }

  _createClass(BanExaminationSubmissionUseCase, [{
    key: "buildUseCase",
    value: function buildUseCase(_ref) {
      var submissionId = _ref.submissionId,
          message = _ref.message;
      var normalizedMessage = message === null || message === void 0 ? void 0 : message.trim();
      var guardCollection = [{
        argument: submissionId,
        argumentName: 'Submission id'
      }, {
        argument: normalizedMessage,
        argumentName: 'Ban message'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded || !normalizedMessage) {
        return Promise.resolve(Result.fail(guardResult.message || 'Ban message is required'));
      }

      return this.examinationSubmissionRepository.ban({
        submissionId: submissionId,
        message: normalizedMessage
      });
    }
  }]);

  return BanExaminationSubmissionUseCase;
}(UseCase);